import { jsxs as d, jsx as r, Fragment as b } from "react/jsx-runtime";
import { useState as x } from "react";
import { useBreakpoint as k, Breakpoints as _, Theme as p, NextgenImage as C, LoaderType as V, GenericLink as B, Button as y, ButtonStyles as T, ButtonSize as N, ButtonWidth as m } from "@nextgen-web-framework/all";
import c from "../SkeletonLoader/SkeletonLoader.js";
import { getCustomThemeColorClass as w, ThemeColor as v, ThemeColorClassTypes as g } from "../../utils/themeColor.js";
import '../../assets/FeaturedArticle.css';const S = "#ffffff", L = "#396e75", O = "#e5fdff", R = "#546223", G = "#f0fae5", W = "#a65523", M = "#fff1e8", D = "#7f3e3e", F = "#ffe2e2", Y = "#62625a", $ = "#f8f8e7", E = "#38539a", j = "#707070", H = "#c8f8d1", K = "#87c9c8", U = "#5291b1", I = "rgba(82, 145, 177, 0.1019607843)", X = "#445685", q = "#181d61", J = "rgba(24, 29, 97, 0.1019607843)", Q = "#5969d6", Z = "#ea999d", A = "#b6577e", P = "rgba(182, 87, 126, 0.1019607843)", ee = "#7e3e80", te = "#1e247f", re = "rgba(30, 36, 127, 0.1019607843)", ae = "#da7600", de = "#107f47", oe = "#d91734", ie = "_html_1xz16_38", t = {
  amwayWhite: S,
  darkBlue: L,
  lightBlue: O,
  darkGreen: R,
  lightGreen: G,
  darkOrange: W,
  lightOrange: M,
  darkRed: D,
  lightRed: F,
  darkYellow: Y,
  lightYellow: $,
  darkPurple: E,
  darkGrayOnWhite: j,
  dataVizColor1: H,
  dataVizColor2: K,
  dataVizColor3: U,
  dataVizColor3Background: I,
  dataVizColor4: X,
  dataVizColor5: q,
  dataVizColor5Background: J,
  dataVizColor6: Q,
  dataVizColor7: Z,
  dataVizColor8: A,
  dataVizColor8Background: P,
  dataVizColor9: ee,
  dataVizColor10: te,
  dataVizColor10Background: re,
  dataVizAlertOrange: ae,
  dataVizSuccessGreen: de,
  dataVizWarningRed: oe,
  "no-visible": "_no-visible_1xz16_34",
  html: ie,
  "theme-border-dark-red": "_theme-border-dark-red_1xz16_143",
  "theme-border-dark-blue": "_theme-border-dark-blue_1xz16_147",
  "theme-border-dark-orange": "_theme-border-dark-orange_1xz16_151",
  "theme-border-dark-green": "_theme-border-dark-green_1xz16_155",
  "theme-border-dark-purple": "_theme-border-dark-purple_1xz16_159",
  "theme-border-dark-gray": "_theme-border-dark-gray_1xz16_163",
  "theme-border-light-red": "_theme-border-light-red_1xz16_167",
  "theme-border-light-blue": "_theme-border-light-blue_1xz16_171",
  "theme-border-light-orange": "_theme-border-light-orange_1xz16_175",
  "theme-border-light-green": "_theme-border-light-green_1xz16_179",
  "theme-border-light-purple": "_theme-border-light-purple_1xz16_183",
  "theme-border-light-gray": "_theme-border-light-gray_1xz16_187",
  "theme-gradient-red": "_theme-gradient-red_1xz16_191",
  "theme-gradient-blue": "_theme-gradient-blue_1xz16_195",
  "theme-gradient-orange": "_theme-gradient-orange_1xz16_199",
  "theme-gradient-green": "_theme-gradient-green_1xz16_203",
  "theme-gradient-purple": "_theme-gradient-purple_1xz16_207",
  "theme-green": "_theme-green_1xz16_211",
  "featured-article-content-container": "_featured-article-content-container_1xz16_214",
  "featured-article-wrapper": "_featured-article-wrapper_1xz16_214",
  "theme-red": "_theme-red_1xz16_218",
  "theme-blue": "_theme-blue_1xz16_225",
  "theme-purple": "_theme-purple_1xz16_232",
  "theme-orange": "_theme-orange_1xz16_239",
  "theme-yellow": "_theme-yellow_1xz16_246",
  "featured-article-card-container": "_featured-article-card-container_1xz16_253",
  "theme-dark-blue": "_theme-dark-blue_1xz16_261",
  "theme-dark-green": "_theme-dark-green_1xz16_265",
  "theme-dark-orange": "_theme-dark-orange_1xz16_269",
  "theme-dark-red": "_theme-dark-red_1xz16_273",
  "theme-dark-purple": "_theme-dark-purple_1xz16_277",
  "theme-dark-gray": "_theme-dark-gray_1xz16_281",
  "theme-light-blue": "_theme-light-blue_1xz16_285",
  "theme-light-green": "_theme-light-green_1xz16_289",
  "theme-light-orange": "_theme-light-orange_1xz16_293",
  "theme-light-red": "_theme-light-red_1xz16_297",
  "theme-light-purple": "_theme-light-purple_1xz16_301",
  "theme-light-gray": "_theme-light-gray_1xz16_305",
  "featured-article-image-container": "_featured-article-image-container_1xz16_309",
  "featured-article-image": "_featured-article-image_1xz16_309",
  "featured-article-wrapper-header": "_featured-article-wrapper-header_1xz16_341",
  "featured-article-title": "_featured-article-title_1xz16_350",
  "featured-article-headline": "_featured-article-headline_1xz16_364",
  "featured-article-description": "_featured-article-description_1xz16_378",
  "featured-article-read-time": "_featured-article-read-time_1xz16_391",
  "featured-article-footer-button": "_featured-article-footer-button_1xz16_402"
}, ce = (e) => {
  var h;
  const n = k(), [s, u] = x(!0), z = [_.SM, _.XS].includes(n), a = (h = e.images) == null ? void 0 : h.find((f) => f.viewport.includes(n)), o = e.themeColor ? w(
    v[e.themeColor],
    e.themeShade
  ) : void 0;
  let i, l;
  return o ? (i = o[g.Base], l = o[g.Button]) : (i = e.cardTheme ?? "theme-black", l = p.BLACK), /* @__PURE__ */ d(
    "div",
    {
      className: `${t["featured-article-card-container"]} ${t[i]}`,
      "data-testid": "featured-article-card-testid",
      "data-pod-name": "commerce",
      children: [
        /* @__PURE__ */ r("div", { className: t["featured-article-image-container"], children: a != null && a.url ? /* @__PURE__ */ d(b, { children: [
          /* @__PURE__ */ r(
            C,
            {
              src: (a == null ? void 0 : a.url) ?? "",
              className: t["featured-article-image"],
              alt: (a == null ? void 0 : a.altText) ?? "",
              onLoad: () => u(!1),
              loaderType: V.CONTENTSTACK
            }
          ),
          s && /* @__PURE__ */ r(c, { className: t["featured-article-image"], isRoundCorner: !1 })
        ] }) : /* @__PURE__ */ r(c, { className: t["featured-article-image"], isRoundCorner: !1 }) }),
        /* @__PURE__ */ d("div", { className: `${t["featured-article-content-container"]}`, children: [
          /* @__PURE__ */ d("div", { className: `${t["featured-article-wrapper"]}`, children: [
            /* @__PURE__ */ d("div", { className: t["featured-article-wrapper-header"], children: [
              e.brandTitle && /* @__PURE__ */ r("h6", { className: t["featured-article-title"], children: e.brandTitle }),
              /* @__PURE__ */ r("h2", { className: t["featured-article-headline"], children: e.brandHeadLine })
            ] }),
            /* @__PURE__ */ r("div", { className: t["featured-article-description"], children: e.brandDescription }),
            e.brandReadTime && /* @__PURE__ */ r("div", { className: t["featured-article-read-time"], children: e.brandReadTime })
          ] }),
          !!e.learnMore.url && /* @__PURE__ */ r("div", { className: t["featured-article-footer-button"], children: /* @__PURE__ */ r(
            B,
            {
              href: e.learnMore.url,
              forceNative: !1,
              target: e.learnMore.target,
              children: /* @__PURE__ */ r(
                y,
                {
                  title: e.learnMore.text,
                  buttonStyle: T.SOLID,
                  theme: l,
                  size: N.MEDIUM,
                  buttonWidth: z ? m.FULL_WIDTH : m.FIT_CONTENT,
                  "data-testid": "featured-article-button-testid",
                  "data-pod-name": "commerce"
                }
              )
            }
          ) })
        ] })
      ]
    }
  );
};
export {
  ce as default
};
//# sourceMappingURL=FeaturedArticle.js.map
